import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import { Modal } from "../../../components/Modal"
import { Button } from "../../../components/Button"
import { AutoComplete } from "../../../components/AutoComplete"
import autoCompleteStyles from "../../../components/AutoComplete/autoCompleteStyles"
import { CreateTrailerPackage } from "../../../api/api.service"

const ManageImportGlobalPackageModal = ({
   isOpen = false,
   onToggleModal = () => {},
   packagesOptions = {},
   setPackagesOptions = () => {},
   handleSearchPackage = () => {},
   selectedPackages = [],
   setSelectedPackages = () => {},
   trailerId = "",
   onSuccess = () => {},
   existingTrailerPackages = [],
}) => {
   const [isLoading, setIsLoading] = useState(false)
   const [existingPackageIds, setExistingPackageIds] = useState([])

   useEffect(() => {
      const ids = existingTrailerPackages.map(pkg => pkg.configuratorPackagesId)
      setExistingPackageIds(ids)
   }, [existingTrailerPackages])

   const handleSelectPackages = selectedOptions => {
      setSelectedPackages(selectedOptions || [])
   }

   const handleRemoveChip = packageToRemove => {
      const updatedPackages = selectedPackages.filter(
         pkg => pkg.value !== packageToRemove.value
      )
      setSelectedPackages(updatedPackages)
   }

   const handleSubmit = async () => {
      if (!selectedPackages || selectedPackages.length === 0) {
         toast.error("Please select at least one package")
         return
      }

      try {
         setIsLoading(true)
         const packageIds = selectedPackages.map(pkg => pkg.value)

         const payload = {
            trailerId: Number(trailerId),
            globalPackageIds: packageIds,
         }

         await CreateTrailerPackage(payload)
         toast.success(
            `${selectedPackages.length} package(s) added successfully!`
         )
         onToggleModal()
         setSelectedPackages([])
         onSuccess()
      } catch (error) {
         toast.error("Failed to add packages")
      } finally {
         setIsLoading(false)
      }
   }

   const handleModalClose = () => {
      setSelectedPackages([])
      setPackagesOptions(prev => {
         return {
            ...prev,
            page: 1,
            Q: "",
         }
      })
      onToggleModal()
   }

   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={handleModalClose}
         bodyClassName=""
         customButton={true}
         hideModalHeaderSeparator={true}
         headerClasses="header-container mb-0"
         size="md"
         backdrop="static"
         modalTitle="Select Packages"
         scrollable
      >
         <div style={{ pointerEvents: isLoading ? "none" : "auto" }}>
            <Row>
               <Col xs={12}>
                  <div className="mb-3">
                     <AutoComplete
                        isMulti
                        handleBlur={() =>
                           setPackagesOptions(prev => {
                              return {
                                 ...prev,
                                 page: 1,
                                 Q: "",
                              }
                           })
                        }
                        onChange={handleSelectPackages}
                        onInputChange={handleSearchPackage}
                        placeholder="Select packages"
                        classNamePrefix="status-header-search-admin"
                        customStyles={autoCompleteStyles.STYLE_TEN}
                        options={packagesOptions?.data}
                        isClearable={true}
                        value={selectedPackages}
                        isLoading={packagesOptions?.fetching}
                        closeMenuOnSelect={false}
                        menuPortalTarget={document.body}
                        isOptionDisabled={option =>
                           existingPackageIds.includes(option.value)
                        }
                     />
                  </div>

                  <div className="mb-3">
                     <div className="Global-selected-features-container">
                        {selectedPackages && selectedPackages.length > 0 ? (
                           <div className="d-flex flex-wrap gap-2">
                              {selectedPackages.map((pkg, index) => (
                                 <span
                                    key={`${pkg.value}-${index}`}
                                    className="Global-feature-chip"
                                 >
                                    <span>{pkg.label}</span>
                                    <button
                                       type="button"
                                       onClick={() => handleRemoveChip(pkg)}
                                       aria-label="Remove"
                                       className="Global-feature-chip-remove-btn"
                                    >
                                       ×
                                    </button>
                                 </span>
                              ))}
                           </div>
                        ) : (
                           <div className="no-features-selected">
                              No packages selected
                           </div>
                        )}
                     </div>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                     <Button
                        isLoading={isLoading}
                        type="button"
                        title="Save"
                        className="header-button"
                        onClick={handleSubmit}
                     />
                  </div>
               </Col>
            </Row>
         </div>
      </Modal>
   )
}

export default ManageImportGlobalPackageModal
